import { jsx, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    highlight: {}
  }),
  { name: "BackstageHighlightedSearchResultText" }
);
const HighlightedSearchResultText = (props) => {
  const { text, preTag, postTag } = props;
  const classes = useStyles();
  const terms = useMemo(
    () => text.split(new RegExp(`(${preTag}.+?${postTag})`)),
    [postTag, preTag, text]
  );
  return /* @__PURE__ */ jsx(Fragment, { children: terms.map(
    (t, idx) => t.includes(preTag) ? /* @__PURE__ */ jsx("mark", { className: classes.highlight, children: t.replace(new RegExp(`${preTag}|${postTag}`, "g"), "") }, idx) : t
  ) });
};

export { HighlightedSearchResultText };
//# sourceMappingURL=HighlightedSearchResultText.esm.js.map
